import { useToast } from '@components/index'
import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { EquipmentModel } from 'types/api'
import { BaseParams } from 'types/utils'

export function useCreateEquipment() {
  const toast = useToast()
  const { t } = useTranslation('toast')
  const queryClient = useQueryClient()

  async function createEquipment({ body }: BaseParams<EquipmentModel, 'POST'>) {
    const response = await apiClient.post(SNA_PREFIX + 'equipments/', body)
    return response.data
  }

  return useMutation({
    mutationFn: createEquipment,
    onSuccess: () => {
      toast.success({ message: t('equipmentCreated') })
      queryClient.invalidateQueries({ queryKey: ['equipment'] })
    },
    onError: () => {
      toast.error({ message: t('equipmentCreateError') })
    }
  })
}
